export const DATE_FORMAT = "YYYY/MM/DD";
export const DATE_DAY_FORMAT = "YYYY/MM/DD dddd";

export const ISSUE_DATE_TIME_FORMAT = "MM/DD HH:mm";
